module.exports = __webpack_public_path__ + "static/media/bars-emoji-strongly-disagree.be5fa73c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/bars-emoji-strongly-disagree.svg
// module id = 688
// module chunks = 0